export default __webpack_public_path__ + "static/media/14_REINSTALLATION-min.9da95616.jpg";